
import { useState, useEffect } from 'react';

export const useFormNavigation = (totalPages, selectedAccountType) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [visitedPages, setVisitedPages] = useState(new Set([0]));
  const [pageErrors, setPageErrors] = useState({}); // NOUVEL ÉTAT

  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      const next = currentPage + 1;
      setCurrentPage(next);
      setVisitedPages(prev => new Set([...prev, next]));
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (pageIndex) => {
    if (visitedPages.has(pageIndex)) {
      setCurrentPage(pageIndex);
    }
  };

  // FONCTION POUR DÉFINIR LES ERREURS D'UNE PAGE
  const setErrorsForPage = (pageIndex, errors) => {
    setPageErrors(prev => ({
      ...prev,
      [pageIndex]: errors
    }));
  };

  // FONCTION POUR VÉRIFIER SI UNE PAGE A DES ERREURS
  const hasPageErrors = (pageIndex) => {
    return pageErrors[pageIndex] && pageErrors[pageIndex].length > 0;
  };

  // Réinitialiser à la première page quand le type de compte change
  useEffect(() => {
    if (selectedAccountType) {
      setCurrentPage(1);
      setVisitedPages(new Set([0, 1]));
      // Réinitialiser les erreurs quand le type change
      setPageErrors({});
    }
  }, [selectedAccountType]);

  return {
    currentPage,
    nextPage,
    prevPage,
    goToPage,
    visitedPages,
    canGoNext: currentPage < totalPages - 1,
    canGoPrev: currentPage > 0,
    isLastPage: currentPage === totalPages - 1,
    //  NOUVELLES FONCTIONNALITÉS POUR LE BLOCAGE DES PAGES ET RENVOIT D'ERREUR ROBUSTE ET CLAIRE
    pageErrors,
    setErrorsForPage,
    hasPageErrors
  };
};